/* eslint-disable max-len */
import React,{useEffect,useCallback,useState, useContext} from 'react'
import { dataService } from '../../services/data.services';
import BranchShimmer from './branchShimmer';
import { CognitoData } from '../../CommonMethods/CognitoData';
import { useNavigate } from 'react-router-dom';
import { hanldeBranch, setUserType, verifyOtp } from '../../pages/auth/authSlice';
import { useDispatch } from 'react-redux';
import GlobalContext from '../Context/GloablContext';
import { AddBranch } from '../../redux/GlobalSlice';
import Loader from '../Loader';

export default function BranchSelection({InstitutionId,handleVerify,currentBranch,handleClose},email) {
    const dispatch=useDispatch()
    const [branches, setbranches] = useState([]);
    const [selectedBranch, setselectedBranch] = useState(currentBranch|| {});
    const {setToastmessage,UpdateCall,setUpdateCall} = useContext(GlobalContext);
    const [loading, setloading] = useState(false)
    const location=useNavigate()
    const generateKeyPair=(arr)=>{
        let myData=[];
        arr.map((val)=>{
            myData.push({
                name:val.branch_name || val.name,
                id:val._id||val.id,
                status:val.status
            })
        })
        return myData
    }
    const getBranch = useCallback(
        async() => {
            
            const branchlist = await CognitoData()
            let res;
            let list=[]
            if(branchlist.idToken.payload['custom:user_type']==='institution-admin'){
                res = await dataService.GetAPI(`branch?institution_id=${branchlist.idToken.payload['custom:institution_id']}&sort=status%2Basc`);
                list=res.data.data.data

            }else{
                res = await dataService.GetAPI(`users/${branchlist.idToken.payload['email']}`);
                list=res.data.data.data.branches


            }
            if(list?.length>0){

                const arr=[];
                setbranches(generateKeyPair(list));
                dispatch(hanldeBranch(generateKeyPair(list)))
                dispatch(AddBranch((generateKeyPair(list))))
                setselectedBranch({
                    name:generateKeyPair(list)[0]?.name,
                    id:generateKeyPair(list)[0]["id"],
                    status:generateKeyPair(list)[0]?.status,
                })
                
            }else{
                setbranches(generateKeyPair(list));
                dispatch(hanldeBranch(generateKeyPair(list)))
                dispatch(AddBranch((generateKeyPair(list))))
                setselectedBranch({
                    name:generateKeyPair(list)[0]?.name,
                    id:generateKeyPair(list)[0]["id"],
                    name:generateKeyPair(list)[0]?.status,
                })
            }
        },
        [],
    )
    useEffect(() => {
        getBranch()
        if(Object.keys(selectedBranch)?.length===0){
            setselectedBranch(JSON.parse(localStorage.getItem('branch_details')))
        }
    }, [getBranch])
    
    return (    
        <>
            <div class="mt-[30px] border border-[#E6E8EA] rounded p-4 pr-1">
                <div class="overflow-auto max-h-[260px] scroll-bar" style={{'min-height':'145px'}}>
                    {branches?.length>0 && branches.map((item,i)=>(
                        <div class="relative custom-radioBlue mb-3 inline-flex w-[90%]"item key={i}>
                            <input 
                                id={`default-radio${i}`} 
                                onChange={()=>setselectedBranch({
                                    name:item.name,
                                    id:item["id"],
                                    status:item["status"],
                                })} 
                                type="radio" 
                                value={`default-radio${i}`}
                                checked={selectedBranch!==null && selectedBranch["id"]===item['id']}
                            />
                            {/*fix here after API change-Anitha-1*/}
                            {item.status!=undefined ? (<label
                                htmlFor={`default-radio${i}`}
                                className={`ml-[30px] text-f2 font-normal cursor-pointer ${item.status ? '' : 'text-[#818e98]'}`}
                                title={`${item.name} (${item.status ? "Active" : "Inactive"})`}
                            >{item.name} {item.status ? "" : "(Inactive)"}</label>) :<>
                                <label
                                    htmlFor={`default-radio${i}`}
                                    class="ml-[30px] text-f2 font-normal text-[#031624] cursor-pointer"
                                    title={item.name?.length > 29 ? item.name : ""}
                                >{item.name} {item.status}</label> </>
                            }
                        </div>
                    ))} 
                    {branches?.length===0 && <BranchShimmer />}
                </div>
            </div>
            <div class="mx-auto h-fit mt-5">
                <button
                    id = "proceed"
                    disabled={selectedBranch===null}
                    onClick={()=>{
                        setloading(true);
                        setTimeout(() => {
                            setloading(false);

                        }, 2000);
                        if(currentBranch){
                            handleVerify(selectedBranch,'Branch switched successfully')

                        }else{
                            handleVerify(selectedBranch)}

                    }
                    }className={`w-[350px] ltr-spcng-8 flex justify-center items-center text-center px-[18px] py-3 rounded ${loading ? 'bg-[#818E98]' : 'bg-[#106EB4]'} text-base font-normal text-[#ffffff] ${!loading?'hover:bg-[#1C8ADC] hover:duration-75':''}  ${selectedBranch!==null && Object.keys(selectedBranch)?.length===0?'cursor-none':'cursor-pointer'}`}>
                    {loading?<span>{<Loader />}</span>:'Proceed'}
                </button>
            </div>
        </>
                           
    )
}
